var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select_wrapper"},[_c('div',{staticClass:"select"},_vm._l((_vm.list),function(item){return _c('p',{key:item.key,class:{'active': _vm.activeValue === item.key,'disabled':_vm.disabled},style:({
                'background': _vm.activeValue === item.key ? item.color:'',
                'box-shadow': _vm.activeValue === item.key ? item.boxShadow : '',
                fontSize: _vm.fontSize,
            }),on:{"click":function($event){!_vm.disabled ? _vm.check(item) : ''}}},[_vm._v(_vm._s(item.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }